var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sliderBarDialogShell',{ref:"shell",staticClass:"addMaterialImgDialog",attrs:{"dialog-show":_vm.dialogShow,"dialog-title":_vm.title},on:{"close":_vm.beforeClose,"submit":_vm.confirm}},[_c('voice-form',{ref:"outform",attrs:{"file-type":_vm.fileType},on:{"submit":_vm.submit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }